import { render } from "./ItemDetails.vue?vue&type=template&id=b732edca&scoped=true"
import script from "./ItemDetails.vue?vue&type=script&lang=js"
export * from "./ItemDetails.vue?vue&type=script&lang=js"

import "./ItemDetails.vue?vue&type=style&index=0&id=b732edca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b732edca"]])

export default __exports__